import { render, staticRenderFns } from "./legislation.vue?vue&type=template&id=c38dbb68"
import script from "./legislation.ts?vue&type=script&lang=js&external"
export * from "./legislation.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports